import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { NIVEIS_SEL } from './constants';

// Utilitário Tailwind (já existente)
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Limpa título da carga
export const limparTitulo = (titulo) => {
  if (!titulo) return 'Sem título';
  return titulo
    .replace(/^Carga\s+de\s+/i, '')
    .replace(/^Carga\s+/i, '')
    .replace(/^Transporte\s+de\s+/i, '')
    .trim();
};

// Formata valor para moeda brasileira
export const formatarValor = (valor) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);
};

// Calcula nível do motorista baseado em contratos
export const calcularNivelMotorista = (contratosConcluidos) => {
  if (contratosConcluidos >= 250) return NIVEIS_SEL.BLACK_DIAMANTE;
  if (contratosConcluidos >= 100) return NIVEIS_SEL.DIAMANTE;
  if (contratosConcluidos >= 50) return NIVEIS_SEL.OURO;
  if (contratosConcluidos >= 10) return NIVEIS_SEL.ESMERALDA;
  return NIVEIS_SEL.BRONZE;
};